import { isObject } from 'lodash';

export const isEditableRowValuesContext = (contextValue: unknown): boolean => {
  return (
    isObject(contextValue) &&
    'editableRowValues' in contextValue &&
    'updateRowValue' in contextValue
  );
};
